import { ciudadesMock, Ciudad } from '../mocks/ciudades.mock';


export const getCiudadesOrdenadas = (): string[] => {
  return [...new Set(ciudadesMock.map((c: Ciudad) => c.Nombre))]
    .sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
};

export const buscarCiudades = (busqueda = ''): string[] => {
  const ciudadesOrdenadas = getCiudadesOrdenadas();
  const search = busqueda.trim().toLowerCase();

  if (!search) {
    return ciudadesOrdenadas; 
  }

  return ciudadesOrdenadas.filter((ciudad) =>
    ciudad.toLowerCase().includes(search)
  );
};

export const getCiudadesPorDepartamento = (departamento: string): Ciudad[] => {
  if (!departamento) return [];

  return ciudadesMock.filter((c) => c.CodigoDepartamento.includes(departamento));
};